<template>
    <div class="public_container">
        <div class="mobile_login_container">
            <div class="phone_login_board">
                <img alt="" src="https://download.hecoos.com/enlightv/2024-32/xsYhfHKXPAECwMcAJFRD.png" class="sass_icon">

                <el-form :model="forgotForm" :rules="forgotFormRules"  ref="forgotForm">
                    <el-form-item prop="account">
                        <el-input placeholder="手机号" v-model="forgotForm.account"></el-input>
                    </el-form-item>
                    <el-form-item prop="code">
                        <el-input maxlength="6" placeholder="验证码" v-model="forgotForm.code">
                            <el-button :disabled="getCodeBtnDisabled" @click="handleClickGetCode()"
                                       slot="suffix"
                                       type="text">
                                {{getCodeText}}
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input placeholder="密码" show-password v-model="forgotForm.password"></el-input>
                    </el-form-item>
                    <el-form-item prop="repassword">
                        <el-input placeholder="确认密码" show-password v-model="forgotForm.repassword"></el-input>
                    </el-form-item>
                    <div class="forget_register_wrap">
                        <span @click="handleClickGoLogin" class="forget_btn">去登录</span>
                    </div>

                    <el-form-item>
                        <el-button  @click="handleClickResetPassword()" class="login_btn" type="primary">重置密码
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>
<script>
import { SendPhoneCode,LoginResetPassword} from "@/api/index";
export default {
    name: 'mobileForgot',
    data () {
        return {
            forgotForm: {
                account: '',
                code: '',
                password: '',
                repassword: '',
            },
            getCodeTime: 60,
            getCodeBtnDisabled: false,
            forgotFormRules: {
                account: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value) return callback(new Error('请输入手机号'))
                            if (!/^1[3456789]\d{9}$/.test(value)) return callback(new Error('请输入正确的手机号'))
                            callback()
                        }
                    },
                ],
                password: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '请输入密码'
                    }
                ],
                repassword: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value) return callback(new Error('请再次输入密码'))
                            if (value != this.forgotForm.password) return callback(new Error('俩次输入的密码不一致'))
                            callback()
                        }
                    }
                ],
                code: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value) return callback(new Error('请输入验证码'))
                            if (!/^\d{6}$/.test(value)) return callback(new Error('请输入6位验证码'))
                            callback()
                        }
                    },
                ],
            },
        }
    },
    computed: {
        getCodeText() {
            if (this.getCodeBtnDisabled) {
                return `${this.getCodeTime}秒后重新发送`;
            } else {
                return '获取验证码';
            }
        }
    },
    mounted () {

    },
    methods: {

        // 获取验证码
        handleClickGetCode() {
            this.$refs.forgotForm.validateField("account", (valid) => {
                if (!valid) {
                    SendPhoneCode({
                        phone: this.forgotForm.account,
                        type: "forget",
                    }).then((res) => {
                        if (res.code === 200) {
                            this.$toast("验证码发送成功");
                            this.getCodeBtnDisabled = true;
                            const timer = setInterval(() => {
                                if (this.getCodeTime > 0) {
                                    this.getCodeTime--;
                                } else {
                                    this.getCodeBtnDisabled = false;
                                    clearInterval(timer);
                                    this.getCodeTime = 60;
                                }
                            }, 1000);
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 去登录
        handleClickGoLogin(){
            this.$router.push({
                name: 'Login'
            })
        },
        // 修改密码
        handleClickResetPassword(){
            this.$refs.forgotForm.validate(valid => {
                if (valid) {
                     LoginResetPassword({
                         account: this.forgotForm.account,
                         code:this.forgotForm.code,
                         password:this.forgotForm.password,
                         repassword:this.forgotForm.repassword,
                    }).then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: "重置密码成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.handleClickGoLogin()
                                },
                            });
                        }
                    });
                }
            })

        },

    },
    components: {}
}
</script>

<style lang="scss" scoped>
</style>
